export default __webpack_public_path__ + "static/media/Paperhand-GG@2x.5ca7c7b8.gif";